
import { RevIllustration } from '@backmarket/design-system'

export default {
  components: {
    RevIllustration,
  },
  props: {
    showArrow: {
      type: Boolean,
      default: false,
    },
  },
}
